import {createSelector} from 'reselect';
import {Types as ChatDataTypes} from '../chat/data';
import {State} from '../../../types/mx/reducers';
import * as MainMenuActions from '../../../actions/MainMenuActions';

export const Types = {
    CHATS_GO_TO_GROUPED_LIST: 'CHATS_GO_TO_GROUPED_LIST',
    CHATS_GO_TO_LOAN_APPS_LIST_AND_LOAD_LIST:
        'CHATS_GO_TO_LOAN_APPS_LIST_AND_LOAD_LIST',
    CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST:
        'CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST',
    CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST_SUCCESS:
        'CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST_SUCCESS',
};

export const INITIAL_STATE = {
    isRefreshing: false,
    loanApplications: {
        byId: {},
    },
    lastPage: 0,
    hasMoreLoanApplications: true,
    firstLevel: '',
    secondLevel: '',
    thirdLevel: '',
};

const data = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST:
            return {
                ...state,
                isRefreshing: action.payload.isRefreshing,
            };
        case Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST_SUCCESS:
            const loanApplicationsById = action.payload.loanApplications.reduce(
                (map, item) => {
                    map[item.hash] = {
                        ...item,
                        id: item.hash,
                        read: true,
                        amount: item.vehiclePrice.displayValue,
                        customerName: item.applicantNames,
                        customerPhone: item.applicantCellPhone,
                        lastObservation: item.statusDescription,
                    };
                    return map;
                },
                {},
            );
            const allLoanApplications =
                action.payload.lastPage === 0
                    ? {
                          ...loanApplicationsById,
                      }
                    : {
                          ...state.loanApplications.byId,
                          ...loanApplicationsById,
                      };
            return {
                ...state,
                isRefreshing: false,
                loanApplications: {
                    byId: allLoanApplications,
                },
                lastPage:
                    action.payload.loanApplications.length === 0
                        ? action.payload.lastPage
                        : action.payload.lastPage + 1,
                hasMoreLoanApplications:
                    action.payload.loanApplications.length > 0,
            };
        case Types.CHATS_GO_TO_GROUPED_LIST:
            return {
                ...INITIAL_STATE,
            };
        case Types.CHATS_GO_TO_LOAN_APPS_LIST_AND_LOAD_LIST:
            return {
                ...state,
                firstLevel: action.payload.firstLevel,
                secondLevel: action.payload.secondLevel,
                thirdLevel: action.payload.thirdLevel,
            };
        case ChatDataTypes.UPDATE_CHAT_INFO: {
            if (action.payload.message) {
                return state;
            }
            const loanSelected =
                state.loanApplications.byId[action.payload.loanApplicationHash];
            return {
                ...state,
                loanApplications: {
                    ...state.loanApplications,
                    byId: {
                        ...state.loanApplications.byId,
                        [action.payload.loanApplicationHash]: {
                            ...loanSelected,
                            chat: {
                                ...loanSelected.chat,
                                pinnedInfo: {
                                    ...loanSelected.chat.pinnedInfo,
                                    pinned: action.payload.pinned,
                                    reason: action.payload.reason,
                                    ...(action.payload.pinned
                                        ? {pinnedAt: {}}
                                        : {}),
                                },
                            },
                        },
                    },
                },
            };
        }
        case MainMenuActions.ON_CLICK_MAIN_MENU_ITEM.name:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default data;

export const Creators = {
    chatsGoToLoanAppsListAndLoadList: (
        firstLevel,
        secondLevel,
        thirdLevel,
        selectedHash = null,
    ) => ({
        type: Types.CHATS_GO_TO_LOAN_APPS_LIST_AND_LOAD_LIST,
        payload: {
            firstLevel,
            secondLevel,
            thirdLevel,
            selectedHash,
        },
    }),
    chatsOnLoadLoanApplicationsList: (
        lastPage,
        isRefreshing,
        selectedHash = null,
        searchQuery = null,
    ) => ({
        type: Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST,
        payload: {lastPage, isRefreshing, selectedHash, searchQuery},
    }),
    chatsOnLoadLoanApplicationsListSuccess: (lastPage, loanApplications) => ({
        type: Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_LIST_SUCCESS,
        payload: {lastPage, loanApplications},
    }),
    chatsGoToGroupedList: () => ({
        type: Types.CHATS_GO_TO_GROUPED_LIST,
    }),
};

export const Selectors = {
    isLoanListSelected: createSelector(
        (state: State) => state.chats.loanApplicationsList.data.firstLevel,
        (state: State) => state.chats.loanApplicationsList.data.secondLevel,
        (state: State) => state.chats.loanApplicationsList.data.thirdLevel,
        (firstLevel, secondLevel, thirdLevel) =>
            !!(firstLevel && secondLevel && thirdLevel),
    ),
    loanApplicationList: createSelector(
        (state: State) =>
            state.chats.loanApplicationsList.data.loanApplications.byId,
        (loanApplications) =>
            Object.keys(loanApplications).map((i) => ({
                ...loanApplications[i],
            })),
    ),
};
